/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S1_P2Inputs */

const en_guide_large_json_files_s1_p2 = /** @type {(inputs: Guide_Large_Json_Files_S1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser-based tools face additional limits: most browsers cap individual tab memory at 1-4 GB. This means a JSON file larger than about 100 MB may cause browser tabs to crash when loaded into a standard JSON viewer.`)
};

const ko_guide_large_json_files_s1_p2 = /** @type {(inputs: Guide_Large_Json_Files_S1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저 기반 도구는 추가적인 제한이 있습니다: 대부분의 브라우저는 개별 탭 메모리를 1-4 GB로 제한합니다. 이는 약 100 MB보다 큰 JSON 파일을 표준 JSON 뷰어에 로드하면 브라우저 탭이 충돌할 수 있음을 의미합니다.`)
};

const ja_guide_large_json_files_s1_p2 = /** @type {(inputs: Guide_Large_Json_Files_S1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザベースのツールにはさらに制限があります: ほとんどのブラウザは個々のタブのメモリを1〜4GBに制限しています。そのため、約100MBを超えるJSONファイルは、標準的なJSONビューアーに読み込むとブラウザタブがクラッシュする可能性があります。`)
};

/**
* | output |
* | --- |
* | "Browser-based tools face additional limits: most browsers cap individual tab memory at 1-4 GB. This means a JSON file larger than about 100 MB may cause brow..." |
*
* @param {Guide_Large_Json_Files_S1_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s1_p2 = /** @type {((inputs?: Guide_Large_Json_Files_S1_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S1_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s1_p2(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s1_p2(inputs)
	return ja_guide_large_json_files_s1_p2(inputs)
});